import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { fetchSlatesForSearch } from 'store/actions/slateViews';
import SlatesSearch from 'components/SlatesSearch';

export default withTranslation()(
  connect(null, { fetchSlatesForSearch })(SlatesSearch),
);
